export function App() {
  return <>Hotel CFAR Root</>;
}
